import { render, staticRenderFns } from "./ModalCreatePvp.vue?vue&type=template&id=463d536e&scoped=true"
import script from "./ModalCreatePvp.vue?vue&type=script&lang=js"
export * from "./ModalCreatePvp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d536e",
  null
  
)

export default component.exports